import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VitalPlate, VitalPlateData } from '../plate';
import { useSessionRoomState } from '../../../../context';

export const VitalManualWeight: FC = () => {
  const { t } = useTranslation(['session-room']);
  const { vitalsData } = useSessionRoomState();
  const [value, units] = useMemo(() => {
    const weight = vitalsData.manualWeight;
    if (!weight?.Value) {
      return ['-', ''];
    }

    return [weight.Value, weight.Unit || ''];
  }, [vitalsData.manualWeight]);

  return (
    <VitalPlate>
      <VitalPlateData
        title={t('session-room:SENSORS.WEIGHT')}
        units={units}
        color="#9b7bff"
        value={value}
      />
    </VitalPlate>
  );
};
